import { render } from "./vehicle-list-page.vue?vue&type=template&id=30529182&scoped=true"
import script from "./vehicle-list-page.vue?vue&type=script&lang=js"
export * from "./vehicle-list-page.vue?vue&type=script&lang=js"

import "./vehicle-list-page.vue?vue&type=style&index=0&id=30529182&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30529182"]])

export default __exports__